export default "__VITE_ASSET__5bHf5Yp2__"